import { IUserOnboardBase } from '../../models/users';
import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUserOnboardsListVenture extends IVentureBase {
  experienceLevels: IVentureExperienceLevelBase[];
}

interface IUserOnboardsListItem extends IUserOnboardBase {
  venture: IUserOnboardsListVenture;
}

export const listUserOnboardsService = async (
  userId?: string,
): Promise<IUserOnboardsListItem[]> => {
  const { data } = await jhsfBookingsApi.get<IUserOnboardsListItem[]>(
    `/users/${userId}/onboards`,
  );

  return data;
};
